import { useMemo, useEffect } from 'react';
import LocationPickerMap from '../LocationPickerMap';
import Icon from '../AppIcon';
import Button from '../ui/Button';
import { useBookingDraft } from '../../contexts/BookingDraftContext';
import { useUserLocation } from '../../contexts/UserLocationContext';
import { buildPreciseLocationFromSelection } from '../../utils/preciseLocationBuilder';

const GlobalLocationModal = ({ isOpen, onClose }) => {
  const { draft, updateDraft } = useBookingDraft();
  const { userLocation, setUserLocationManually } = useUserLocation();

  const initialCenter = useMemo(() => {
    if (draft?.preciseLocation?.lat && draft?.preciseLocation?.lng) {
      return {
        lat: draft.preciseLocation.lat,
        lng: draft.preciseLocation.lng,
      };
    }

    if (userLocation?.lat && userLocation?.lng) {
      return {
        lat: userLocation.lat,
        lng: userLocation.lng,
      };
    }

    // Fallback: Riyadh center
    return { lat: 24.7136, lng: 46.6753 };
  }, [draft, userLocation]);

  // إخفاء القائمة السفلية أثناء اختيار الموقع (نفس map-modal-open في PreciseLocationStep)
  useEffect(() => {
    if (!isOpen) return;
    document.body.classList.add('map-modal-open');
    return () => document.body.classList.remove('map-modal-open');
  }, [isOpen]);

  if (!isOpen) return null;

  const handleLocationSelect = (selection) => {
    const updateData = buildPreciseLocationFromSelection(selection, draft || {});

    if (!updateData || !updateData.preciseLocation) {
      return;
    }

    const nextDraft = {
      ...(draft || {}),
      ...updateData,
      locationSource: 'global-header',
    };

    updateDraft(nextDraft);

    setUserLocationManually({
      lat: updateData.preciseLocation.lat,
      lng: updateData.preciseLocation.lng,
      city: updateData.preciseLocation.city || null,
      district: updateData.preciseLocation.district || null,
    });

    // setUserLocationManually يحفظ تلقائياً في mashhad_user_location — لا حاجة لمفاتيح إضافية

    onClose();
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 px-4 py-6" dir="rtl">
      <div className="relative w-full max-w-xl bg-white rounded-2xl shadow-2xl border border-slate-200 max-h-[90vh] flex flex-col">
        <div className="flex items-center justify-between px-4 py-3 border-b border-slate-100">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-full bg-primary/10 flex items-center justify-center">
              <Icon name="MapPin" size={18} className="text-primary" />
            </div>
            <div className="text-right">
              <h2 className="text-sm font-semibold text-slate-900">
                اختر موقعك
              </h2>
              <p className="text-[11px] text-slate-500">
                سيتم استخدام هذا الموقع لعرض المصورين القريبين وتعبئة الحجز تلقائياً
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="p-1.5 rounded-full hover:bg-slate-100 text-slate-500 transition-colors"
            aria-label="إغلاق"
          >
            <Icon name="X" size={18} />
          </button>
        </div>

        <div className="p-4 space-y-3 overflow-y-auto">
          <LocationPickerMap
            initialCenter={initialCenter}
            onLocationSelect={handleLocationSelect}
            onCancel={onClose}
          />
        </div>

        <div className="px-4 pb-4 pt-2 border-t border-slate-100">
          <p className="text-[11px] text-slate-500 text-right">
            يمكنك تغيير هذا الموقع لاحقاً من نفس المكان في الهيدر أو أثناء خطوات الحجز.
          </p>
        </div>
      </div>
    </div>
  );
};

export default GlobalLocationModal;

